<template>
  <span :style="`font-size:${fontSize}px`">
    <svg class="icon" aria-hidden="true">
      <use :xlink:href="'#' + icon" />
    </svg>
  </span>
</template>
<script>
export default {
	props: {
		icon: {
			type: String,
			default: ''
		},

		fontSize: {
			type: String,
			default: '24'
		}
	}
}
</script>

<style>
</style>